module.exports = {
  commandStack: [ 'type', require(285) ]
};
